<form [formGroup]="form">
  <div class="buttonWrapper">
    <gl-checkbox
      [ngModel]="stack"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onStack()"
      >{{ 'stack' | translate }}
      </gl-checkbox
      >
      <div class="inputRow">
        <span>{{ 'stack_quantity' | translate }}:</span>
        <gl-input-container >
          <input data-ctx="input-stack-quantity" type="number" normal-input formControlName="stackQuantity" min="1" />
        </gl-input-container>
        <gl-modal-hint class="info">
          <img class="infoImage" src="../../../../../assets/svg/stackingInfo.svg" />
          <p>
            {{ 'stack_quantity_message_info' | translate }}
          </p>
        </gl-modal-hint>
      </div>
    </div>

    <div class="buttonWrapper">
      <gl-checkbox
        [ngModel]="weightOfFloors"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onWeightOfFloors()"
        [ngClass]="{ disabledCheckbox: !stack }"
        >{{ 'weight_of_floors' | translate }}
        </gl-checkbox
        >
        <div class="inputRow">
          <span>{{ 'specify_max_weight' | translate }}:</span>
          <gl-input-container>
            <input type="number" normal-input formControlName="maxWeight" />
          </gl-input-container>
          <gl-modal-hint class="info">
            <img class="infoImage" src="../../../../../assets/svg/weightInfo.svg" />
            <p>
              {{ 'weight_of_floors_info' | translate }}
            </p>
          </gl-modal-hint>
        </div>
      </div>
      <div class="buttonWrapper withoutInput">
        <gl-checkbox
          [ngModel]="stackAlongFloor"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onStackAlongFloor()"
          [ngClass]="{ disabledCheckbox: !stack }"
          >{{ 'stack_along_floor' | translate }}
          </gl-checkbox
          >
          <gl-modal-hint class="info">
            <img class="infoImage" src="../../../../../assets/svg/stackAlongFloorInfo.svg" />
            <p>
              {{ 'stack_along_floor_info' | translate }}
            </p>
          </gl-modal-hint>
        </div>
        @if (loadData?.loadType !== 1 && loadData?.loadType !== 2) {
          <div class="buttonWrapper">
            <gl-checkbox
              [disabled]="!(loadsGroups.length > 0)"
              [ngModel]="chooseLoadsToStack"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onChooseLoadsToStack()"
              [ngClass]="{ disabledCheckbox: isMyLoads}"
              >{{ 'choose_loads_to_stack' | translate }}
              </gl-checkbox
              >
              <div class="inputRow">
                <gl-select formControlName="load" [isDisabled]="isSelectDisabled" data-ctx="select-load">
                  @for (group of loadsGroups; track group) {
                    <gl-option
                      [value]="group.id"
                      [label]="group.nameTranslated"
                      [loadType]="true"
                      class="loadOption"
                      >
                      <gl-checkbox
                        [defaultChecked]="checkboxLoads[group.id]"
                        [ngModel]="checkboxLoads[group.id]"
                        (ngModelChange)="setStackGroup(group.id)"
                        [ngModelOptions]="{ standalone: true }"
                        [ngClass]="{ disabledCheckbox: isSelectDisabled }"
                        >
                        <div class="groupColor" [ngStyle]="{ 'background-color': getColor(group) }"></div>
                        {{ group.nameTranslated }}
                        </gl-checkbox
                        >
                        </gl-option
                        >
                      }
                    </gl-select>
                    <gl-modal-hint class="info">
                      <img class="infoImage" src="../../../../../assets/svg/loadsToStackInfo.svg" />
                      <p>
                        {{ 'choose_loads_to_stack_info' | translate }}
                      </p>
                    </gl-modal-hint>
                  </div>
                </div>
              }
              @if (loadData?.loadType !== 1 && loadData?.loadType !== 2) {
                <div class="buttonWrapper">
                  <gl-checkbox
                    [ngModel]="specifyPercentageOfSupport"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onSpecifyPercentageOfSupport()"
                    >{{ 'specify_percentage_of_support' | translate }}
                    </gl-checkbox
                    >
                    <div class="inputRow">
                      <gl-slider
                        data-ctx="slider-pct"
                        [unit]="'%'"
                        [max]="100"
                        [min]="50"
                        [isDisabled]="false"
                        formControlName="supportPercentage"
                        class="supportPercentage"
                      ></gl-slider>
                      <gl-modal-hint class="info">
                        <img class="infoImage" src="../../../../../assets/svg/percentageOfSupportInfo.svg" />
                        <p>
                          {{ 'specify_percentage_of_support_info' | translate }}
                        </p>
                      </gl-modal-hint>
                    </div>
                  </div>
                }
              </form>
